module.exports = __webpack_public_path__ + "img/photo-gallery.f8fc6274.svg";